import { Upload } from 'hlj-components'
import { Button, Modal } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import {
  arrayMove,
  SortableContainer,
  SortableElement
} from 'react-sortable-hoc'
import { CASE_CONTENT_IMAGE_LIMIT } from '../../../../constants'
import style from './style.module.less'

const SortableList = SortableContainer(({ children }) => {
  return <div className={style.picturePanel}>{children}</div>
})

const SortableItem = SortableElement(({ children }) => children)

const PictureItem = ({ path, onClick }) => (
  <div className={style.pictureItem}>
    <div className={style.closeIcon} onClick={onClick}>
      <img
        style={{ width: 28 }}
        src={'//qnm.hunliji.com/o_1dbrjhe131ugfs68v4g1vq2i8q9.png'}
      />
    </div>
    <img className={style.picture} src={path + '?imageView2/2/w/400'} />
  </div>
)

@observer
export default class extends Component {
  sortEnd = ({ oldIndex, newIndex }) => {
    const { imgListPreview } = this.props.store
    this.props.store.sortPicture(arrayMove(imgListPreview, oldIndex, newIndex))
  }
  render() {
    const {
      imgListPreview,
      clearPreview,
      savePreview,
      deletePreviewPicture,
      uploadPicture,
      imgModalStatus,
      getUploadPictureLength,
      imgNum,
      preLength,
      restCaseImageNum
    } = this.props.store

    const { onSubmit } = this.props
    return (
      <Modal
        title={
          <p>
            <span>上传图片</span>
          </p>
        }
        visible={imgModalStatus}
        width={752}
        height={557}
        onCancel={clearPreview}
        maskClosable={false}
        className={style.picturemodal}
        destroyOnClose
        footer={
          <div>
            <span style={{ float: 'left', marginLeft: 8 }}>
              还可以上传{restCaseImageNum}张图片，你可以拖拽调整图片位置
            </span>
            <Button type="default" onClick={clearPreview}>
              取消
            </Button>
            <Button
              onClick={() => savePreview(onSubmit)}
              disabled={
                preLength != 0 &&
                preLength > imgListPreview.length &&
                imgNum + preLength < CASE_CONTENT_IMAGE_LIMIT
              }
              type="primary"
            >
              保存
            </Button>
          </div>
        }
      >
        <div className={style.tipswapper}>
          <div className={style.tips}>
            1. 请勿在图片添加任何文字、水印、logo，以免审核不通过；<br />
            2.支持JPG、PNG和BMP等大部分格式，图片高度在8192像素以下，图片大小不可大于10M；<br />
            3. 支持多张图片同时上传，支持在本弹框拖拽调整顺序。
          </div>
          <Upload
            key={new Date().getTime()}
            multiple={true}
            onOk={uploadPicture}
            onAdded={files => getUploadPictureLength((files || []).length)}
            autoSizeError
            max_file_size="10mb"
            filters={{
              mime_types: [
                {
                  title: 'images files',
                  extensions: 'jpg,png,jpeg,bmp'
                }
              ],
              max_file_size: '10mb',
              prevent_duplicates: true
            }}
          >
            <div className={style.addimg}>添加图片</div>
          </Upload>
        </div>

        <SortableList
          onSortEnd={this.sortEnd}
          axis="xy"
          hideSortableGhost={false}
        >
          {imgListPreview.map((el, i) => (
            <SortableItem disabled={false} key={i} index={i}>
              <PictureItem path={el.link} onClick={deletePreviewPicture(i)} />
            </SortableItem>
          ))}
        </SortableList>
      </Modal>
    )
  }
}
